import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { domain } from '../../../../environments/environment';
import { RouterLink } from '@angular/router';
import { PaintDirective } from '../../../paint.directive';
import { MatButtonModule } from '@angular/material/button';
import { LocationService } from '../../../location.service';

@Component({
  selector: 'use-guide',
  templateUrl: './use-guide.component.html',
  styleUrls: ['./use-guide.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, PaintDirective, MatButtonModule]
})
export default class UseGuideComponent {
  router = inject(LocationService);

  queryParams: { [key: string]: string } = {
    path: '/mygifts',
    url: encodeURI(domain + '/get-the-app'),
    utm_source: this.router.initialURL?.searchParams?.get('utm_source') || 'find-your-gifts',
    utm_medium: this.router.initialURL?.searchParams?.get('utm_medium') || 'web',
    store: '1',
    pv: '95'
  };

}
